define('casino/ingameFunctionalities',['jquery' ], function ($) {
    'use strict';

    var DEFAULT_SIZE_BUTTON = 's24-normal';
    var EXPANDED_SIZE_BUTTON = 's24-expanded';
    var MAXIMIZED_SIZE_BUTTON = 's24-maximized';

    var ALLOW_SHOWING_OF_DEPOSIT_AND_FEED_WHEN_RESOLUTION_LOW = 0;
    var DO_NOT_ALLOW_SHOWING_OF_DEPOSIT_AND_FEED_WHEN_RESOLUTION_LOW = -2;

    var HARDCODED_GAME_MARGIN_PIXELS = 10;
    var BOTH_SIDE_MARGINS_WIDTH = 2 * HARDCODED_GAME_MARGIN_PIXELS;

    var MAXIMUM_SIZE_OF_FEED_OR_DEPOSIT = 240;
    var COMPACT_SIZE_OF_FEED_OR_DEPOSIT = 170;

    var $feed = $('#activity-feed');
    var $feedInner = $('#activity-feed-inner');

    function isNormalButtonChecked() {
        var $sizeSelected = $('#casino-ingame').find('#size-mode').find('.toggle a.active span');
        return $sizeSelected.hasClass(DEFAULT_SIZE_BUTTON);
    }

    function isExpandedButtonChecked() {
        var $sizeSelected = $('#casino-ingame').find('#size-mode').find('.toggle a.active span');
        return $sizeSelected.hasClass(EXPANDED_SIZE_BUTTON);
    }

    function isMaximizedButtonChecked() {
        var $sizeSelected = $('#casino-ingame').find('#size-mode').find('.toggle a.active span');
        return $sizeSelected.hasClass(MAXIMIZED_SIZE_BUTTON);
    }

    function calculateGameFrameSize() {
        var $gameHolder = $('#casino-ingame').find('.game-holder');
        var $gameLoader = $gameHolder.find('.game').find('iframe,object');

        if (isGroupLoaded()) {
            return $gameHolder.find('.inner').width();
        }
        return $gameLoader.width();
    }

    function resizeGameFrameToShowOrNotFeedAndDeposit(showOrNotFeedAndDeposit) {

        var $gameHolder = $('#casino-ingame').find('.game-holder');
        var $gameLoader = $gameHolder.find('.game').find('iframe,object');
        var gameGroup = $gameHolder.find('.game-group');
        var $background = $gameHolder.find('.background');
        var $inner = $gameHolder.find('.game-group .inner');
        var originalWidth;
        var originalHeight;
        var width;
        var subtractWidth;
        var innerGameHolder = $gameHolder.find('.inner');
        if (isGroupLoaded()) {
            originalWidth = innerGameHolder.width();
            originalHeight = innerGameHolder.height();
        } else {
            originalWidth = $gameLoader.width();
            originalHeight = $gameLoader.height();
        }

        if (showOrNotFeedAndDeposit === ALLOW_SHOWING_OF_DEPOSIT_AND_FEED_WHEN_RESOLUTION_LOW) {
            subtractWidth = 2 * COMPACT_SIZE_OF_FEED_OR_DEPOSIT + BOTH_SIDE_MARGINS_WIDTH - calculateWindowSizeWithoutGameFrame();
            if (isGroupLoaded()) {
                width = innerGameHolder.width() - subtractWidth;
            } else {
                width = $gameLoader.width() - subtractWidth;
            }
        } else if (showOrNotFeedAndDeposit === DO_NOT_ALLOW_SHOWING_OF_DEPOSIT_AND_FEED_WHEN_RESOLUTION_LOW) {
            width = Number(sessionStorage.getItem('defaultSizeOfResizedGame'));

        }

        var height = Math.round(width / (originalWidth / originalHeight));

        if (isGameLoaded()) {
            $gameLoader.width(width).height(height);
            $background.width(width).height(height);
        }

        if ($inner.width() > width) {
            $inner.width(width);
        } else {
            $inner.css('width', '');
        }

        var $gameGroup = $gameHolder.find('.game-group');
        $gameGroup.css('margin-top', '');
        $inner.width('');

        var $buttons = $gameHolder.find('.game-group .buttons');
        $buttons.width('');

        var $a = $buttons.find('a');
        $a.width('');
        if ($buttons.width() > width) {
            $buttons.width(width);
            $a.width(width / 2 - BOTH_SIDE_MARGINS_WIDTH);
            $gameGroup.css('margin-top', '5%');
            $inner.width(width);
        }

        if (isGameLoaded()) {
            saveGameSize($gameHolder, width, height);
        } else {
            gameGroup.width('');
            gameGroup.css('margin-top', '5%');
            $background.width(width);
            $background.height(height - 30);
            $background.find('img').css('width', width + 20);
        }

        $('.game-wrapper').width(width + 2 * BOTH_SIDE_MARGINS_WIDTH);

    }

    function isGameLoaded() {
        var $gameHolder = $('#casino-ingame').find('.game-holder');
        var isGameLoad = $gameHolder.find('.game').find('iframe,object');
        return isGameLoad.length > 0 && isGameLoad.css('display') !== 'none';
    }

    function isGroupLoaded() {
        var $gameHolder = $('#casino-ingame').find('.game-holder');
        var gameGroup = $gameHolder.find('.game-group');
        return gameGroup.css('display') !== 'none';
    }


    function saveGameSize($gameHolder, width, height) {
        $gameHolder.find('.game').data({width: width, height: height});
    }

    function checkIfElementHasDisplayBlock() {
        return $feed.css('display') === 'block';
    }

    function isFeedMediumSize() {
        var hasClassCompact = $feed.hasClass('compact');
        var hasClassExpanded = $feed.hasClass('expanded');
        return hasClassCompact && hasClassExpanded && checkIfElementHasDisplayBlock();
    }

    function checkIfInnerFeedHasDisplayNone() {
        return $feedInner.css('display') === 'none' || ($feedInner.css('display') === 'none' && $feedInner.css('opacity') === '1');
    }

    function isFeedIcon() {
        return checkIfInnerFeedHasDisplayNone();
    }

    function checkIfFeedHasDisplayNone() {
        return $feed.css('display') === 'none';
    }

    function isFeedHidden() {

        if ( checkIfFeedHasDisplayNone()) {
            return true;
        } else if (!checkIfFeedHasDisplayNone() && checkIfInnerFeedHasDisplayNone()) {
            return true;
        }

        return false;
    }

    function isFeedMaximumSize() {
        var hasClassExpanded = $feed.hasClass('expanded');
        return hasClassExpanded || (hasClassExpanded && checkIfElementHasDisplayBlock() && !checkIfFeedHasDisplayNone());
    }

    function calculateWindowSizeWithoutGameFrame() {

        var sizeOfGameFrame = $('.game-holder').width();
        var windowSize = $(window).width();

        return windowSize - (sizeOfGameFrame + BOTH_SIDE_MARGINS_WIDTH);
    }

    function isAllowedToAddMaximumFeedAndDeposit() {
        return calculateWindowSizeWithoutGameFrame() - 2 * MAXIMUM_SIZE_OF_FEED_OR_DEPOSIT >= 0;
    }

    function isAllowedToAddCompactFeedAndDeposit() {
        return calculateWindowSizeWithoutGameFrame() - 2 * COMPACT_SIZE_OF_FEED_OR_DEPOSIT >= 0;
    }

    var ingameFunctionalities = {
        isNormalButtonChecked: isNormalButtonChecked,
        isExpandedButtonChecked: isExpandedButtonChecked,
        isMaximizedButtonChecked: isMaximizedButtonChecked,
        resizeGameFrameToShowOrNotFeedAndDeposit: resizeGameFrameToShowOrNotFeedAndDeposit,
        isGameLoaded: isGameLoaded,
        isGroupLoaded: isGroupLoaded,
        isFeedMediumSize: isFeedMediumSize,
        isFeedIcon: isFeedIcon,
        isFeedHidden: isFeedHidden,
        isFeedMaximumSize: isFeedMaximumSize,
        ALLOW_SHOWING_OF_DEPOSIT_AND_FEED_WHEN_RESOLUTION_LOW: ALLOW_SHOWING_OF_DEPOSIT_AND_FEED_WHEN_RESOLUTION_LOW,
        DO_NOT_ALLOW_SHOWING_OF_DEPOSIT_AND_FEED_WHEN_RESOLUTION_LOW: DO_NOT_ALLOW_SHOWING_OF_DEPOSIT_AND_FEED_WHEN_RESOLUTION_LOW,
        isAllowedToAddMaximumFeedAndDeposit: isAllowedToAddMaximumFeedAndDeposit,
        isAllowedToAddCompactFeedAndDeposit: isAllowedToAddCompactFeedAndDeposit,
        calculateGameFrameSize: calculateGameFrameSize
    };

    return ingameFunctionalities;
});

